/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';

import BulmaContainer from 'react-bulma-components/lib/components/container';
import BulmaSection from 'react-bulma-components/lib/components/section';

import { Heading, LazyLink } from '../atoms';

import { createRandomId } from '../../util/createRandomId';
import { linkResolver } from '../../util/linkResolver';

import {
  styledPricingSection,
  styledPricingContainer,
  styledColHeading,
  styledHeading,
  styledSubtitle,
  StyledSubnote,
  StyledRecommend,
  StyledCol,
  StyledCards,
  StyledPricing,
} from './PricingComparisonMinimalStyles';

const PricingComparisonMinimal = ({ input }) => {
  const {
    text_color,
    background_color,
    background_image,
    button_color,
    cta_button_text,
    cta_button_url,
    heading,
    heading_color,
    subheading,
    subheading_color,
    subnote,
    target_name,
  } = input.primary;
  const { fields } = input;

  return (
    <BulmaSection
      css={styledPricingSection}
      style={{
        backgroundImage: `url(${background_image && background_image.url})`,
        backgroundColor: background_color,
        paddingTop: `${!heading && !subheading ? '64px' : null}`,
        paddingBottom: `${!heading && !subheading ? '64px' : null}`,
      }}
    >
      <BulmaContainer css={styledPricingContainer} id={target_name}>
        {heading && heading[0].text ? (
          <Heading
            style={heading_color ? { color: heading_color } : null}
            css={styledHeading}
            className={text_color === 'light' ? 'h2 white' : 'h2 darkblue'}
            renderAs="h2"
          >
            {heading[0].text}
          </Heading>
        ) : null}
        {subheading && subheading[0].text ? (
          <Heading
            style={subheading_color ? { color: subheading_color } : null}
            css={styledSubtitle}
            subtitle
            className={text_color === 'light' ? 'medium white' : 'medium darkgrey'}
            renderAs="p"
          >
            {subheading[0].text}
          </Heading>
        ) : null}

        <StyledCards>
          {fields.map(col => {
            const { title1, recommended, pricing_copy, price, interval } = col;
            return (
              <StyledCol className={recommended ? 'recommended' : ''} key={createRandomId()}>
                {recommended && <StyledRecommend>Recommended</StyledRecommend>}
                <Heading css={styledColHeading} className="h4 lightblue" renderAs="h4">
                  {title1[0].text}
                </Heading>
                <StyledPricing>
                  {pricing_copy || null} <span className="currency">$</span>
                  <span className="price">{price || 0}</span>
                  <span className="interval"> / {interval || null}</span>
                </StyledPricing>
              </StyledCol>
            );
          })}
        </StyledCards>
        {subnote && (
          <StyledSubnote className={text_color === 'light' ? 'medium white' : 'medium darkgrey'}>
            <RichText render={subnote} linkResolver={linkResolver} />
          </StyledSubnote>
        )}
        {cta_button_url && cta_button_url.url ? (
          <LazyLink className={`button-link is-${button_color}`} url={cta_button_url.url}>
            {cta_button_text}
          </LazyLink>
        ) : null}
      </BulmaContainer>
    </BulmaSection>
  );
};

export default PricingComparisonMinimal;

PricingComparisonMinimal.propTypes = {
  input: PropTypes.object.isRequired,
};
